// extracted by mini-css-extract-plugin
export default {"listHeader":"participants_list-module___listHeader___a62b5620","list":"participants_list-module___list___d5fd8a90"};